import SliderInterests from './SliderInterests'

export default SliderInterests
